import icons from '../../assets/icons';
import ConstructionIcon from '@mui/icons-material/Construction';
import EventIcon from '@mui/icons-material/Event';
import CountsIcon from '@mui/icons-material/Pin';
import SignalIcon from '@mui/icons-material/Traffic';
import VideoIcon from '@mui/icons-material/Videocam';
import CloudIcon from '@mui/icons-material/Cloud';
import TravelTimeIcon from '@mui/icons-material/Speed';
import TollingIcon from '@mui/icons-material/Toll';
import ConnectedVehicleIcon from '@mui/icons-material/CellTower';
import { useTranslation } from 'react-i18next';
import { StatusBarIconProps, StatusBarIconMap } from './types';
import useStatusBarIconStyles from './styles';
import { DirectionsCar, EditRoad, LocalParking, Radio } from '@mui/icons-material';

const StatusBarMenuIcon: React.FunctionComponent<StatusBarIconProps> = ({ className, module }) => {
  const { t } = useTranslation('common');
  const classes = useStatusBarIconStyles();

  let icon = null;
  switch (module) {
    case StatusBarIconMap.ASSET_MANAGEMENT:
      icon = <ConstructionIcon fontSize='small' />;
      break;
    case StatusBarIconMap.COUNTS:
      icon = <CountsIcon fontSize='small' />;
      break;
    case StatusBarIconMap.EVENTS:
      icon = <EventIcon fontSize='small' />;
      break;
    case StatusBarIconMap.SIGNALS:
      icon = <SignalIcon fontSize='small' />;
      break;
    case StatusBarIconMap.SIGNS:
      icon = <img src={icons.signIcon} alt={t('SIGNS')} className={classes.icon} />;
      break;
    case StatusBarIconMap.TRAVELTIME:
      icon = <TravelTimeIcon fontSize='small' />;
      break;
    case StatusBarIconMap.TOLLING:
      icon = <TollingIcon fontSize='small' />;
      break;
    case StatusBarIconMap.VIDEO:
      icon = <VideoIcon fontSize='small' />;
      break;
    case StatusBarIconMap.WEATHER:
      icon = <CloudIcon fontSize='small' />;
      break;
    case StatusBarIconMap.GATES:
      icon = <img src={icons.gateController} alt={t('GATES')} className={classes.icon} />;
      break;
    case StatusBarIconMap.PARKING:
      icon = <LocalParking fontSize='small' />;
      break;
    case StatusBarIconMap.ROADASSISTANCE:
      icon = <DirectionsCar fontSize='small' />;
      break;
    case StatusBarIconMap.CONNECTED_VEHICLES:
      icon = <ConnectedVehicleIcon fontSize='small' />;
      break;
    case StatusBarIconMap.ROAD_CONDITIONS:
      icon = <EditRoad fontSize='small' />;
      break;
    case StatusBarIconMap.HAR_TRANSMITTER:
      icon = <Radio fontSize='small' />;
      break;
    case StatusBarIconMap.RAMP_METER:
      icon = <img src={icons.rampMeterIcon} alt={t('rampMeter')} className={classes.icon} />;

      break;
    default:
      icon = null;
      break;
  }
  return <div className={className}>{icon}</div>;
};

export default StatusBarMenuIcon;
